/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fecha from 'fecha';
import '../../styles/mobileSearchBar.css';
import { CityPicker } from './CityPicker';
import IrctcAuthorizedPartner from './IrctcAuthorizedPartner';
import { addDaysToToday, crawlerDuplicateAvoidStyle, isMobile } from '../../utils/commonUtils';
import { createTrackingCallback } from '../../utils/getPageSectionName';
import MobileCalendar from './MobileCalendar';
import { getRouteTemplateId } from '../../utils/vernacularConfig';
import SingleDayPicker from '@React_UI_Lib/SingleDayPicker';
import CustomModal from '../components/CustomModal';
import { SEO_ROUTE_PAGE } from '../../utils/RailsSEOConstants';

const Station = ({ station, label, onClick }) => (
  <div className="postionRelative">
    <div onClick={onClick} className={'station loaderOnClick'} tabindex="0">
      <span className={'label'}>{label}</span>
      <div className={'makeFlex hrtlCenter align__text row'}>
        <span className={'stnCode'}>{station.code ? `${station.code}, ` : ''}</span>
        <span className={'cityName'}>{station.cityMweb ? station.cityMweb : station.city}</span>
      </div>
    </div>
  </div>
);

const DateField = ({ date, label, onClick }) => {
  return (
    <div className="postionRelative">
      <div className={'station loaderOnClick'} tabindex="0">
        <span className={'label'}>{label}</span>
        <div onClick={onClick} className={'makeFlex hrtlCenter align__text row'}>
          <span className={'cityName'}>{date[2]}</span>
          &nbsp;
          <span className={'cityName'}>{date[1]}</span>
          {date.length > 0 && <span className={'stnCode'}>&#44;</span>}
          <span className={'stnCode'}>{date[0]}</span>
        </div>
      </div>
    </div>
  );
};

Station.propTypes = {
  station: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

function MobileSearchBar({
  fromStationNode,
  toStationNode,
  isCalendarOpen,
  closeCalendar,
  openCalendar,
  setToCity,
  setFromCity,
  trainNumber,
  modifySearchProps = false,
  templateId = 1,
  searchButtonTitle = 'Select Date and Check Availability',
  initialDateProp = addDaysToToday(7),
  pageName
}) {
  const getDateArray = (date) => {
    return date.toString().split(' ').slice(0, 3);
  };

  const [fromStn, setFromStn] = useState(fromStationNode);
  const [toStn, setToStn] = useState(toStationNode);
  const [selectMode, setSelectMode] = useState('from');
  const [showCityPicker, setShowCityPicker] = useState(false);
  const [modifySearch, setModifySearch] = useState(modifySearchProps);
  const [date, setDate] = useState(getDateArray(initialDateProp)); // DATE ARRAY
  const [dateSelected, setDateSelected] = useState(initialDateProp); // DATE OBJECT

  useEffect(() => {
    if (isMobile() && pageName === SEO_ROUTE_PAGE) {
      openCalendar();
    }
  }, []);

  function setDateArray(date) {
    const dateArray = getDateArray(date);
    setDateSelected(date);
    setDate(dateArray);
  }

  useEffect(() => {
    setFromStn(fromStationNode);
    setToStn(toStationNode);
  }, [fromStationNode, toStationNode]);

  function onFromStationClicked() {
    const trackingCb = createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_stationfrom_click');
    trackingCb();
    setSelectMode('from');
    setShowCityPicker(true);
  }

  function onToStationClicked() {
    const trackingCb = createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_stationto_click');
    trackingCb();
    setSelectMode('to');
    setShowCityPicker(true);
  }

  function onCalenderClicked() {
    const trackingCb = createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_date_click');
    trackingCb();
    openCalendar();
  }

  function onStationSelected(station) {
    if (selectMode === 'from' && station) {
      setFromCity(station.city, station.stationCode);
    } else if (selectMode === 'to' && station) {
      setToCity(station.city, station.stationCode);
    }
    setShowCityPicker(false);
  }

  function onDateSelected(date) {
    closeCalendar();
    setDateArray(date);
    gotoListing(null, date);
  }

  function onSearchClicked() {
    const trackingCb = createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_search_click');
    trackingCb();
    if (modifySearch) {
      setModifySearch(false);
    } else {
      gotoListing();
    }
  }

  function gotoListing(evt, date) {
    if (!fromStn.code || !toStn.code) return;
    const doj = date ? date : dateSelected;
    const dateStr = fecha.format(doj, 'YYYYMMDD');
    const lang = getRouteTemplateId(templateId);
    window.location.href =
      'https://www.makemytrip.com/railways/search/railsListingPage?' +
      'isSeo=true' +
      '&from_city=' +
      `${fromStn.cityMweb ? fromStn.cityMweb : fromStn.city}` +
      '&from=' +
      fromStn.code +
      '&to_city=' +
      `${toStn.cityMweb ? toStn.cityMweb : toStn.city}` +
      '&to=' +
      toStn.code +
      '&departure=' +
      dateStr +
      '&trainNumber=' +
      trainNumber +
      '&selectedLang=' +
      lang;
  }

  const RenderCalendarComponent = () => {
    const today = new Date();
    const lastAllowedDate = new Date();
    const numberOfDaysToAdd = today.getHours() > 8 || (today.getHours() === 8 && today.getMinutes() > 15) ? 63 : 62;
    lastAllowedDate.setDate(lastAllowedDate.getDate() + numberOfDaysToAdd);
    const disabledDays = {
      before: today,
      after: lastAllowedDate
    };
    return (
      <CustomModal customClass="width-90" close={closeCalendar}>
        <SingleDayPicker onDaySelect={onDateSelected} disabled={disabledDays} />
      </CustomModal>
    );
  };

  return (
    <>
      <div style={crawlerDuplicateAvoidStyle} className={'mobileShow'}>
        <div className={'mobileSearchBar'}>
          {!modifySearch && (
            <div className={'header'}>
              <span className={'mmtLogo'} />
              <span className={'mobileSearchBarCloseContainer'} onClick={() => setModifySearch(true)}>
                <span
                  className={'close'}
                  onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_closebutton_click')}
                >
                  Close
                </span>
                <span
                  className={'mobileSearchBarCloseIcon'}
                  onClick={createTrackingCallback(pageName, 'rail_seo_{{pageSectionName}}_closebutton_click')}
                />
              </span>
            </div>
          )}
          {!modifySearch && (
            <div className={'stations'}>
              <div className={'fromToStationRow'}>
                <Station label={'FROM'} station={fromStn} onClick={onFromStationClicked} />
                <Station label={'TO'} station={toStn} onClick={onToStationClicked} />
              </div>
              <DateField label={'DATE'} date={date} onClick={onCalenderClicked} />
            </div>
          )}
          {modifySearch && (fromStn.cityMweb || fromStn.city) && (toStn.cityMweb || toStn.cityMweb) && (
            <div className={'modify'}>
              <div>
                <span className={'cityName'}>
                  {fromStn.cityMweb ? fromStn.cityMweb : fromStn.city} to {toStn.cityMweb ? toStn.cityMweb : toStn.city}{' '}
                  Trains.
                </span>
              </div>
              <span>
                <span className={'date'}>{date[0]}</span>
                {date.length > 0 && <span className={'date'}>&#44;</span>}
                &nbsp;
                <span className={'date'}>{date[2]}</span>
                &nbsp;
                <span className={'date'}>{date[1]}</span>
                &nbsp;
              </span>
            </div>
          )}
          <div className="postionRelative">
            <div className={'button loaderOnClick'} onClick={onSearchClicked} tabIndex="0">
              {modifySearch ? 'Modify Search' : 'Search'}
            </div>
          </div>
          {showCityPicker && <CityPicker onCitySelected={onStationSelected} />}
          {isCalendarOpen && <RenderCalendarComponent />}
        </div>
        <IrctcAuthorizedPartner />
      </div>
    </>
  );
}

MobileSearchBar.propTypes = {
  fromStationNode: PropTypes.object.isRequired,
  toStationNode: PropTypes.object.isRequired,
  closeCalendar: PropTypes.func,
  openCalendar: PropTypes.func,
  setToCity: PropTypes.func,
  setFromCity: PropTypes.func,
  isCalendarOpen: PropTypes.bool,
  trainNumber: PropTypes.string,
  pageName: PropTypes.string
};

MobileSearchBar.defaultProps = {
  closeCalendar: undefined,
  openCalendar: undefined,
  isCalendarOpen: false,
  trainNumber: ''
};

export default MobileSearchBar;
